var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chem-container-attach-wrapper chemtracker-module",
    attrs: {
      "data-test": "outside-vif"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Container Attachments")]), _vm._v(" "), _vm.showFileListing ? _c('div', [_c('file-attachment-listing', {
    attrs: {
      "files": _vm.entity.field_chemical_container_files,
      "allow-file-download": "",
      "allow-file-remove": _vm.editMode
    },
    on: {
      "file-deleted": _vm.deleteAttachedFile
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.editMode ? _c('b-img', {
    staticClass: "upload-photos-icon",
    attrs: {
      "id": "upload-photos-icon",
      "src": _vm.getUploadPhotosIconPath,
      "alt": "Upload Attachments"
    }
  }) : _vm._e(), _vm._v(" "), _vm.editMode ? _c('div', {
    staticClass: "upload-photos-wrapper"
  }, [_c('b-row', [_c('b-col', [_c('b-form-file', {
    attrs: {
      "label": "Attach new file",
      "id": "chem_container_files",
      "multiple": "",
      "accept": "image/jpeg, image/png, image/gif, application/pdf, application/msword,\n            application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n            application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, text/csv"
    },
    model: {
      value: _vm.newFiles,
      callback: function ($$v) {
        _vm.newFiles = $$v;
      },
      expression: "newFiles"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }